/* START_MODULE_CONTRACT
 * PURPOSE: Секция внутри модальной формы с overline-заголовком.
 * SCOPE: FormSection.
 * DEPENDS: MUI Box, Typography
 * LINKS: M-FE-APP
 * ROLE: RUNTIME
 * MAP_MODE: EXPORTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * FormSection - группировка полей формы с подписью секции.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-14 - Секции для форм задач и сотрудников.
 * END_CHANGE_SUMMARY
 */

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/* START_METHOD_FormSection */
/* START_CONTRACT: FormSection
 * PURPOSE: Обёртка секции формы с overline-меткой.
 * INPUTS: { label: string, children: ReactNode, first?: boolean }.
 * OUTPUTS: { JSX.Element }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-APP
 * END_CONTRACT: FormSection
 */
export default function FormSection({ label, children, first = false }) {
  return (
    <Box sx={{ mt: first ? 0 : 2.5 }}>
      <Typography
        variant="overline"
        component="h3"
        sx={{
          display: 'block',
          color: 'text.secondary',
          fontWeight: 600,
          letterSpacing: '0.1em',
          lineHeight: 1.4,
          mb: 1.5,
        }}
      >
        {label}
      </Typography>
      {children}
    </Box>
  );
}
/* END_METHOD_FormSection */
